module.exports = __webpack_public_path__ + "static/img/01.af5d6c07.png";